var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoSolid = function SvgInfoSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "info-solid_svg__a",
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "info-solid_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#info-solid_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#info-solid_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8 12c0 .2-.2.4-.4.4H6.7c-.2 0-.4-.2-.4-.4v-.9c0-.2.2-.4.4-.4h.4V8h-.4c-.3 0-.5-.2-.5-.4v-.9c0-.2.2-.4.4-.4h1.8c.2 0 .4.2.4.4v4h.4c.2 0 .4.2.4.4v.9zM7.1 4c0-.2.2-.4.4-.4h.9c.2 0 .4.2.4.4v.9c0 .2-.2.4-.4.4h-.8c-.2 0-.4-.2-.4-.4V4zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "&quot"
    }
  })));
};
export default SvgInfoSolid;